import { Trans } from 'react-i18next';
import { Flex, TextComponent } from '@monorepo/react-components';

export const WaitingWithdrawBanner = () => {
  return (
    <Flex justify="center" align="center" className="waiting-withdraw-banner">
      <TextComponent level={6}>
        <Trans
          i18nKey="dashboardTemplates:waiting_withdraw_banner"
          components={{ strong: <strong /> }}
        />
      </TextComponent>
    </Flex>
  );
};
